import { Component, input, inject } from '@angular/core';
import { AvatarComponent } from '../avatar/avatar.component';
import { CommonModule } from '@angular/common';
import { StudentSyncStatus } from '../../../domains/organization/organization/models/StudentSyncStatus';
import { UserSyncStatusIconComponent } from '../../../domains/organization/organization/components/user-sync-status-icon/user-sync-status-icon.component';
import { FeatureFlagsService } from '../../../core/services/feature-flag.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatMenuModule, MatMenuPanel } from '@angular/material/menu';

@Component({
  selector: 'app-user-card',
  imports: [
    AvatarComponent,
    CommonModule,
    UserSyncStatusIconComponent,
    TranslocoPipe,
    MatMenuModule,
  ],
  templateUrl: './user-card.component.html',
  styleUrl: './user-card.component.css',
})
export class UserCardComponent {
  private readonly featureFlagsService = inject(FeatureFlagsService);

  readonly username = input.required<string>();
  readonly email = input.required<string>();
  readonly syncStatus = input<StudentSyncStatus>();
  readonly highlightUsername = input(true);
  readonly isCurrentUser = input(false);
  readonly useNewAvatarStyle = input(false);
  readonly allowEmailWrap = input(false);
  readonly hasHighlightCircle = input(false);
  readonly menu = input<MatMenuPanel | null>(null);

  isHRISEnabled() {
    return this.featureFlagsService.isFeatureEnabled(
      this.featureFlagsService.hris,
    );
  }

  generateInitials() {
    const username = this.username();
    if (!username) {
      return '';
    }

    const words = username.split(' ');
    const initials = words.map((word) => word[0]).join('');
    return initials.toUpperCase();
  }
}
